import { startCase } from 'lodash';

const MASTER_LEVEL_SEGMENT = 'consignmentMasterLevel';

/**
 * A readable name for the field a pointer ends on: `transportEquipment.0.seal` reads as
 * "Transport Equipment - Seal".
 *
 * The positions are dropped because the level they belong to is already named separately, and
 * repeating "0" in the label would only reintroduce the 0-based counting the location model
 * exists to hide. The master level prefix goes too, as the location already names the level.
 */
export const formatIcs2FieldPath = (fieldPath?: string): string | undefined => {
    if (!fieldPath) return undefined;

    const parts = fieldPath
        .split('.')
        .filter((segment) => segment && segment !== MASTER_LEVEL_SEGMENT && !/^\d+$/.test(segment))
        .map((segment) => startCase(segment));

    return parts.length ? parts.join(' - ') : undefined;
};
